import { win } from '@rei/browser-shim';

var doc = win.document;
var canGetComputedStyle = !!win.getComputedStyle;

/**
 * Get Window Size
 * Finds the content string from the :after element
 * on the document body or returns none if not set
 * @returns {string}: window size ('xs', 'sm', etc.) or 'none'
 */
export var getWindowSize = function getWindowSize() {
  if (canGetComputedStyle) {
    var contentString = win.getComputedStyle(doc.body, ':after').getPropertyValue('content');
    return contentString.replace(/\W/g, '');
  }
  return 'none';
};

/**
 * is Window Size ____ ?
 * @param size {string}: size to check against (specified in src/main.less)
 * @returns {boolean}: whether window size matches your requested size
 */
export var isWindowSize = function isWindowSize(size) {
  return size === getWindowSize();
};

/* deprecated window size check functions */
export var isNone = function isNone() {
  return isWindowSize('') || isWindowSize('none');
};
export var isXS = function isXS() {
  return isWindowSize('xs');
};
export var isSmall = function isSmall() {
  return isWindowSize('s');
};
export var isMedium = function isMedium() {
  return isWindowSize('m');
};
export var isLarge = function isLarge() {
  return isWindowSize('l');
};